import { MissingData } from '../../enums/enumRegistry';
import { formatDurationInSeconds } from '../../utils/commonfunctions';

export function getLaunchExecutionDurationDisplay(isVisibleExecutionDuration, durationMs) {
  if (isVisibleExecutionDuration === false) {
    return MissingData.NONE;
  }
  return formatDurationInSeconds(durationMs);
}
